export default __webpack_public_path__ + "static/media/product.69f3e646.png";